import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import supabase from '../../supabase';
import finalcancel from '../../assets/finalcancel.svg';
import Star from '../star';
import { useEffect } from 'react';

export default function GuestForm({ token, invite }) {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    
    const [actualRating, setStars] = useState(5);
    const [content, setContent] = useState(''); 
    const [text, setText] = useState('');
    const [firstName, setFirstName] = useState(invite?.customer_name?.split(' ')[0] || '');
    const [lastName, setLastName] = useState(invite?.customer_name?.split(' ').slice(1).join(' ') || '');

    const todayObj = new Date();
    const todayStr = todayObj.toISOString().split('T')[0]; 
    const yearAgoObj = new Date();
    yearAgoObj.setFullYear(todayObj.getFullYear() - 1);
    const yearAgoStr = yearAgoObj.toISOString().split('T')[0];
    
    const [dateOfExperience, setDateOfExperience] = useState(todayStr);

    // Add this inside your GuestForm component, before other logic:

useEffect(() => {
    const checkSession = async () => {
        const { data: { session } } = await supabase.auth.getSession();
        if (session?.user) {
            // If they are logged in, they shouldn't be here. Redirect.
            navigate(`/verify-feedback/authorized/${token}`, { replace: true });
        }
    };
    checkSession();
}, [token, navigate]);

    const getWindowStarColor = (starIndex) => {
        if (starIndex <= actualRating) {
            switch (actualRating) {
                case 5: return 'bg-five'; 
                case 4: return 'bg-four';
                case 3: return 'bg-three';
                case 2: return 'bg-two';
                case 1: return 'bg-one';
                default: return 'bg-[#E4E4E4] opacity-40';
            }
        }
        return 'bg-[#E4E4E4] opacity-40';
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!firstName.trim() || !lastName.trim()) {
            alert("Please provide both your first and last name.");
            return;
        }

        setLoading(true);
        try {
            const { data, error } = await supabase.functions.invoke('submit-verified-review', {
                body: {
                    token: token,
                    reviewData: {
                        stars: actualRating,
                        title: content,
                        text: text,
                        author: `${firstName.trim()} ${lastName.trim()}`,
                        date: dateOfExperience
                    }
                }
            });

            if (error || data?.success === false) throw new Error(data?.message || "Submission failed");
            navigate(`/company/${invite.businesses.www}`);
        } catch (err) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='flex flex-col w-full max-w-[700px] bg-white rounded-[6px] mt-[60px] border border-[#F2F2F2] mx-auto my-[40px] p-[16px] xs:p-[32px] shadow-sm relative z-20'>
            <form onSubmit={handleSubmit}>
                <div className='flex flex-row justify-between items-center'>
                    <div className='flex gap-[4.7px] xs:gap-[5.7px]'>
                        {[1, 2, 3, 4, 5].map((index) => (
                            <div key={`win-star-${index}`} onClick={() => setStars(index)} className="cursor-pointer">
                                <Star 
                                    bgColor={getWindowStarColor(index)} 
                                    boxheight={'h-[32px] xs:h-[55px]'} 
                                    boxwidth={'w-[32px] xs:w-[55px]'} 
                                    width={'w-[18px] xs:w-[30px]'}
                                />
                            </div>
                        ))}
                    </div>
                    <img className='w-[32px] cursor-pointer' onClick={() => navigate(-1)} src={finalcancel} alt="cancel" />
                </div>

                {/* --- VERIFICATION UPGRADE BANNER --- */}
                <div className='mt-[24px] bg-[#F9FAFB] border border-[#E5E7EB] rounded-[6px] p-4 flex flex-col xs:flex-row items-center justify-between gap-4'>
                    <div className='text-center xs:text-left'>
                        <p className='text-[14px] font-semibold text-[#111827]'>Want a "Verified" badge?</p>
                        <p className='text-[12px] text-[#6B7280]'>Authorize via social login for maximum credibility.</p>
                    </div>
                    <button 
                        type="button"
                        onClick={() => navigate(`/verify-feedback/authorized/${token}`)}
                        className='whitespace-nowrap text-[13px] font-medium text-[#1C6065] border border-[#1C6065] px-4 py-2 rounded-[4px] hover:bg-[#1C6065] hover:text-white transition-all'
                    >
                        Switch to Authorized
                    </button>
                </div>

                <div className='flex flex-col gap-[24px] xs:gap-[32px] mt-[24px] xs:mt-[32px]'>
                    <div className='flex flex-col xs:flex-row gap-[24px] xs:gap-[20px]'>
                        <div className='flex flex-col gap-[10px] flex-1'>
                            <label className='font-noto font-regular text-[#1a1a1a] text-[16px]'>First Name *</label>
                            <input 
                                type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)}
                                placeholder="John" className='w-full min-h-[45px] border border-[#F6F6F6] rounded-[4px] p-3 outline-none' required
                            />
                        </div>
                        <div className='flex flex-col gap-[10px] flex-1'>
                            <label className='font-noto font-regular text-[#1a1a1a] text-[16px]'>Last Name *</label>
                            <input 
                                type="text" value={lastName} onChange={(e) => setLastName(e.target.value)}
                                placeholder="Doe" className='w-full min-h-[45px] border border-[#F6F6F6] rounded-[4px] p-3 outline-none' required
                            />
                        </div>
                    </div>

                    <div className='flex flex-col gap-[10px]'>
                        <label htmlFor="title" className='font-noto font-regular text-[#1a1a1a] text-[16px]'>Testimonial Title</label>
                        <input 
                            id="title" type="text" value={content} onChange={(e) => setContent(e.target.value)}
                            placeholder="Quick and trustworthy" className='w-full min-h-[45px] border border-[#F6F6F6] rounded-[4px] p-3 outline-none' required
                        />
                    </div>
                        
                    <div className='flex flex-col gap-[10px]'>
                        <label htmlFor="review" className='font-noto font-regular text-[#1a1a1a] text-[16px]'>Experience Details</label>
                        <textarea 
                            id="review" value={text} onChange={(e) => setText(e.target.value)}
                            placeholder="They authenticated my item in just 2 days..." className='w-full min-h-[105px] border border-[#F6F6F6] rounded-[4px] p-3 outline-none' rows={4} required
                        />
                    </div>

                    <div className='flex flex-col gap-[10px]'>
                        <label htmlFor="date" className='font-noto font-regular text-[#1a1a1a] text-[16px]'>Date of Experience</label>
                        <input 
                            type="date" 
                            value={dateOfExperience}
                            min={yearAgoStr}
                            max={todayStr}
                            onChange={(e) => setDateOfExperience(e.target.value)}
                            className="w-full min-h-[45px] border border-[#F6F6F6] rounded-[4px] p-3 outline-none"
                        />
                    </div>

                    <button 
                        type="submit" disabled={loading}
                        className='w-[256px] h-[50px] rounded-[5px] bg-[#56AB75] text-[18px] font-noto font-medium text-white mt-[8px] mx-auto block transition-opacity disabled:opacity-50'
                    >
                        {loading ? 'Submitting...' : 'Submit Testimonial'}
                    </button>
                </div>
            </form> 
        </div>
    );
}